import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

interface WarningDialogProps {
  header: string;
  isVisible: boolean;
  onHide: () => any;
  addIcon?: boolean;
  content: string;
  quoteName?: string;
  dangerousContent?: string;
  smallLetters?: string;
  notInformation?: string;
  onConfirm?: () => void | Promise<void>;
  confirmLabel?: string;
  confirmLoading?: boolean;
  cancelLabel?: string;
  showButtons?: boolean;
}

export const WarningDialog: React.FC<WarningDialogProps> = ({
  header,
  isVisible,
  onHide,
  addIcon = false,
  content,
  quoteName,
  dangerousContent,
  smallLetters,
  notInformation,
  onConfirm,
  confirmLabel = 'אישור',
  confirmLoading = false,
  cancelLabel = 'ביטול',
  showButtons = true,
}) => {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
  };

  const dialogFooter = showButtons ? (
    <div>
      <Button
        label={cancelLabel}
        icon="pi pi-times"
        className="p-button-outlined p-button-secondary"
        onClick={onHide}
        disabled={confirmLoading}
      />
      {onConfirm && (
        <Button
          label={confirmLabel}
          icon="pi pi-check"
          className="p-button-danger"
          onClick={handleConfirm}
          loading={confirmLoading}
          disabled={confirmLoading}
          autoFocus
        />
      )}
    </div>
  ) : undefined;

  return (
    <Dialog
      header={header}
      visible={isVisible}
      onHide={() => {
        if (!confirmLoading) {
          onHide();
        }
      }}
      style={{
        width: '500px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      footer={dialogFooter}
      closable={!confirmLoading}
      modal
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <div style={{ textAlign: addIcon ? 'center' : 'right' }}>
          {addIcon && (
            <i
              className="pi pi-exclamation-triangle"
              style={{
                fontSize: '3rem',
                color: '#f59e0b',
                marginBottom: '16px',
                display: 'block',
              }}
            />
          )}

          <p
            style={{
              fontSize: addIcon ? '1.1rem' : '1rem',
              color: '#495057',
              fontWeight: 'bold',
              marginBottom: quoteName
                ? '8px'
                : dangerousContent || smallLetters
                  ? '16px'
                  : '0',
            }}
          >
            {content}
          </p>

          {quoteName && (
            <p
              style={{
                fontSize: '1.2rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: dangerousContent || smallLetters ? '16px' : '0',
              }}
            >
              "{quoteName}"
            </p>
          )}

          {dangerousContent && (
            <p
              style={{
                fontSize: '0.9rem',
                color: '#dc2626',
                marginBottom: smallLetters
                  ? '16px'
                  : notInformation
                    ? '24px'
                    : '0',
              }}
            >
              <i className="pi pi-info-circle" style={{ marginLeft: '4px' }} />
              {dangerousContent}
            </p>
          )}

          {smallLetters && (
            <p
              style={{
                fontSize: '0.9rem',
                color: '#6b7280',
                marginBottom: notInformation ? '24px' : '0',
              }}
            >
              {smallLetters}
            </p>
          )}
        </div>

        {notInformation && (
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '16px',
              backgroundColor: '#fef3cd',
              padding: '16px',
              borderRadius: '8px',
              border: '1px solid #ffc107',
            }}
          >
            <i
              className="pi pi-info-circle"
              style={{ fontSize: '1.5rem', color: '#856404', marginTop: '2px' }}
            />
            <p
              style={{
                margin: 0,
                fontSize: '0.95rem',
                color: '#856404',
                lineHeight: '1.5',
              }}
            >
              {notInformation}
            </p>
          </div>
        )}
      </div>
    </Dialog>
  );
};
